const global = () => {
  $(document).ready(function () {
    window.scrollTo(0, 0)

    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    var position = $(window).scrollTop()

    function changeHeaderStyle() {
      var scroll = $(window).scrollTop()
      if (scroll > 30) {
        $('.site-header').addClass('on-scroll')
      } else {
        $('.site-header').removeClass('on-scroll')
      }
      position = scroll
    }
    // should start at 0

    changeHeaderStyle()

    $(window).scroll(function () {
      changeHeaderStyle()
    })

    $('#mobile_menu_thumb').on('click', function () {
      $('#mobile_menu').removeClass('closed')
    })

    $('#mobile_menu .btn-close').on('click', function () {
      $('#mobile_menu').addClass('closed')
    })

    $('#btn_search').on('click', function () {
      $('.site-header .input-search').toggleClass('hide')
      $(this).toggleClass('hide')
    })

    $('.input-search').keypress(function (e) {
      if (e.which == 13) {
        window.location.href = `/search?query=${e.target.value}`
      }
    })

    $('.search-input-mobile input').keypress(function (e) {
      if (e.which == 13) {
        window.location.href = `/search?query=${e.target.value}`
      }
    })
  })
}

export default global
